import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

import { IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-file-data-my-suffix-detail',
    templateUrl: './file-data-my-suffix-detail.component.html'
})
export class FileDataMySuffixDetailComponent implements OnInit {
    fileData: IFileDataMySuffix;

    constructor(private activatedRoute: ActivatedRoute,
        private languageChangeService: LanguageChangeService,
        ) {
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ fileData }) => {
            this.fileData = fileData;
        });
    }

    previousState() {
        window.history.back();
    }
}
